import { BrowserModule,Title,Meta } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER,enableProdMode } from '@angular/core';
import { RouterModule, Routes }  from '@angular/router';
//import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';
import { routing } from './app.route';
import {SharedAppModule} from './app.shared.module';
import { ValidationService } from './services/validation.service';
import { LoaderService } from './services/Spinner.service';
//import { ControlMessagesComponent } from './control-messages.component';
// import { SignupComponent } from './users/signup.component'; 
// import { AgmCoreModule } from 'angular2-google-maps/core'; 
//import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import { BsDropdownModule } from 'ngx-bootstrap';
// import { HomeComponent } from './users/home.component';

import { HttpClientModule, HttpClient } from '@angular/common/http';

import { CarouselModule } from 'ngx-bootstrap/carousel';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
//import { DragScrollModule } from 'angular2-drag-scroll';

// import { UserResetrpasswordComponent } from './users/resetpassword.component';
//  import {onesignal} from './localdb/onesignal';
// import { NglModule } from 'ng-lightning/ng-lightning';

//Advetiser section
// import { AdvertiserComponent } from './advertiser/advertiser.component';
// import { AdSignupComponent } from './advertiser/ad-signup.component';
// import { AdLoginComponent } from './advertiser/ad-login.component';
// import { ProfileComponent } from './advertiser/user-profile.component';
// import { LoginComponent } from './users/login.component';
// import { FillComponent } from './users/fill.component';
// import { CompaignComponent } from './advertiser/compaign/compaign.component';
// import { CreateCompaignComponent } from './advertiser/compaign/createcompaign.component';
// import {Tabs} from './advertiser/compaign/tabs';
// import {Tab} from './advertiser/compaign/tab';
import {Ng2PaginationModule} from 'ng2-pagination';
// import { InterestComponent } from './users/interest.component';
// import { FooterComponent } from './common/footer.component';
// import { adFooterComponent } from './common/adfooter.component';
// import { ResetrpasswordComponent } from './advertiser/resetpassword.component';
// import { LoaderComponent } from './common/loader.component';

//End Advetiser section
import { ModalModule } from 'angular2-modal';
// import { BootstrapModalModule } from 'angular2-modal/plugins/bootstrap';
import { BootstrapModalModule } from 'ng2-bootstrap-modal';
// import { WallComponent } from './users/wall/wall.component';
// import { WallNotificationComponent } from './users/wall/wall.notification.component';
// import { AccountComponent } from './users/account/account.component';
// import { SettingsComponent } from './users/account/settings.component';
// import { TermsComponent } from './users/terms.component';
// import { PrivacyComponent } from './users/privacy.component';
// import { adPrivacyComponent } from './advertiser/privacy.component';
// import { HowToDocumentComponent } from './advertiser/how-to-document.component';

// import { adTermsComponent } from './advertiser/terms.component';
// import { CustomizeSegmentComponent } from './users/customize-segment.component';
// import { LocationComponent } from './users/location.component';
// import { UpdatepasswordComponent } from './users/account/updatepassword.component';
// import { DeleteuseraccountComponent } from './users/account/deleteuseraccount.component';
// import { HeaderMenuComponent } from './common/headermenu.component';
// import { HeaderMenuAccountComponent } from './common/headermenuAccount.component';

// import { UserSideMenuComponent } from './common/usersidemenu.component';
import { LocalStorage } from './services/local-storage';

 import { PopupSignupComponent } from './users/popup/popup-signup.component';
// import { PopupInterestComponent } from './users/popup/popup.interest.component';
// import { PopupIphoneComponent } from './users/popup/popup-iphone.component';

 import { PopupReportComponent } from './users/popup/popup-report.component';
// import { PopupDetailComponent } from './users/popup/popup-detail.component';
 import { PopupLogoutComponent } from './users/popup/popup-logout.component';

// import { UserHeaderBeforeLoginComponent } from './common/user-header-before-login.component';
// import { UserHeaderBeforeSignupComponent } from './common/user-header-before-signup.component';
// import { PopupContactComponent } from './common/popup-contact.component';

// import { AdvHeaderBeforeLoginComponent } from './common/adv-header-before-login.component';
// import { AdvHeaderBeforeSignupComponent } from './common/adv-header-before-signup.component';

// import { HomeSideMenuComponent } from './common/homesidemenu.component';
import { AuthGuard } from './guards/auth.guard.component';
import { AuthGuardRoute } from './guards/auth.guard.route.component';
// import { ResetconfirmComponent } from './users/resetconfirm.component';
import { InfiniteScrollModule } from 'angular2-infinite-scroll';
import { ImageUploadModule } from 'angular2-image-upload';

// import { LocaldbComponent } from './localdb/localdb.component';

// import { AddResetconfirmComponent } from './advertiser/resetconfirm.component';
// import { FeedtrackingComponent } from './feedtracking/feedtracking.component';



import { TodoComponent } from './todo.component';
import { Entity, Todo } from './models/entity'; // Entity classes.

import { DatePickerModule } from 'ng2-datepicker';
//import {ImageCropperComponent, CropperSettings} from 'ng2-img-cropper';
import { UiSwitchModule } from 'ngx-toggle-switch/src';

import { IndexedDBService } from './services/indexdb.service';
// import { NouisliderModule } from 'ng2-nouislider';

// import { NouisliderComponent } from 'ng2-nouislider';
// import { AdlandingComponent } from './advertiser/adlanding.component';

// import { AdaccountComponent } from './advertiser/adaccount/adaccount.component';

// import { CampaignListComponent } from './advertiser/campaign-list/campaign-list.component';
// import { DraftCampaignComponent } from './advertiser/campaign-list/draftcampaign.component';
// import { ViewCampaignComponent } from './advertiser/campaign-list/viewcampaign.component';

// import { AdvHeaderComponent } from './common/adv-header/adv-header.component';
// import {socketservice} from './services/socket.service';
import { PopupLogComponent } from './advertiser/popup/popup-log.component';
// import { CoupanCheckComponent } from './advertiser/popup/coupan-check.component';
 import { ImageCroperComponent } from './advertiser/popup/imageCroper.component';

import {LyResizingCroppingSmallImageModule} from './alyle-ui-profile/index';

import {AlyleUIModule,LyResizingCroppingImageModule} from './alyle-ui';

 import { profileimageCroperComponent } from './advertiser/popup/profileimageCroper.component';

import { DeleteConfirmComponent } from './advertiser/popup/delete-confirm.component';
import { ZizDeleteConfirmComponent } from './users/popup/ziz-delete-confirm.component';

// import { MyDatePickerModule } from 'mydatepicker';
import { AdminImageCroperComponent } from './admin/shared/components/popupAdmin/popup-imagecropper.component';

import { PopupSegmentComponent } from './admin/shared/components/popupAdmin/popup-segment.component';
import { payreceiptComponent } from './advertiser/compaign/payreceipt.component';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { MessageService } from './services/sharedName.service';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

// import { TruncatePipe } from './pipe/exponential-strength.pipe';



import { AdminLoginComponent } from './admin/login/login.component';
import { AdminResetconfirmComponent } from './admin/resetConfirm/resetconfirm.component';
import { ResetpasswordComponent } from './admin/resetPassword/resetpassword.component';
import { UpdatePasswordComponent } from './admin/updatepassword/updatepassword.component';
import { SettingsComponent } from './admin/settings/settings.component';
import { LayoutComponent } from './admin/layout/layout.component';
import { UsersComponent } from './admin/layout/users/users.component';
import { SidebarComponent } from './admin/shared/components/sidebar/sidebar.component';
import { HeaderComponent } from './admin/shared/components/header/header.component';
import { ActiveAdvertisementsComponent } from './admin/layout/activeadvertisements/activeadvertisements.component';
import { AdvertisersComponent } from './admin/layout/advertisers/advertisers.component';
import { AdminWallComponent } from './admin/layout/advertisers/wall.component';
import { CompanyDetailsComponent } from './admin/layout/companyDetails/companyDetails.component';
import { AdvertiserUploadComponent } from './admin/layout/advertiserUpload/advertiserUpload.component';
import { KeywordsComponent } from './admin/layout/keywords/keywords.component';
import { PhrasesComponent } from './admin/layout/phrases/phrases.component';
import { TransactionsComponent } from './admin/layout/transactions/transactions.component';
import { CouponCodeComponent } from './admin/layout/couponCode/couponcode.component';
import { CreateCouponCodeComponent } from './admin/layout/couponCode/createcouponcode.component';
import { TargetAudienceCouponCodeComponent } from './admin/layout/couponCode/targetaudcouponcode.component';
import { BranchCompanyComponent } from './admin/layout/couponCode/branchcompany.component';
import { CompanyInfoComponent } from './admin/layout/couponCode/companyinfo.component';
import { BranchInfoComponent } from './admin/layout/couponCode/branchinfo.component';
import { Data } from "./admin/layout/couponCode/data";
import { BasePriceStatesComponent } from './admin/layout/pricingdetails/basepriceStates.component';
import { BasePriceUsersComponent } from './admin/layout/pricingdetails/basepriceUsers.component';
import { PriceGroupComponent } from './admin/layout/pricingdetails/pricegroup.component';
import { ReportedContentComponent } from './admin/layout/reportedContent/reportedcontent.component';
import { UsersReportedListComponent } from './admin/layout/reportedContent/userreportedlist.component';
import { SegmentsComponent } from './admin/layout/segments/segments.component';
import { CreateSegmentsComponent } from './admin/layout/updateCreateSegments/Createsegments.component';
import { UpdateSegmentsComponent } from './admin/layout/updateCreateSegments/Updatesegments.component';



// import { LandingComponent } from './users/landing.component';
import { UsersModule} from './users/users.module';
import { AdvertiserModule } from './advertiser/advertiser.module';
import { PaymentComponent } from './admin/layout/payment/payment.component';
@NgModule({
  declarations: [
    AppComponent,
    // LandingComponent,



    // TruncatePipe,
//    // ControlMessagesComponent,
//     SignupComponent,
//     LoginComponent,
//     CompaignComponent,
//     Tab,
//     Tabs,
//     AdvertiserComponent,
//     CreateCompaignComponent,
//     AdSignupComponent,
//     AdLoginComponent,
//     ProfileComponent,
//     HomeComponent,
//     InterestComponent,
    // FooterComponent,
//     adFooterComponent,
//     HeaderMenuComponent,
//     HeaderMenuAccountComponent,
//     ResetrpasswordComponent,
//     UserResetrpasswordComponent,
//     LoaderComponent,
//     WallComponent,
//     WallNotificationComponent,
//     AccountComponent,
//     CustomizeSegmentComponent,
//     TermsComponent,
//     adTermsComponent,
//     adPrivacyComponent,
//     HowToDocumentComponent,
//     CustomizeSegmentComponent,
//    LocationComponent,
//    UserSideMenuComponent,
//   UpdatepasswordComponent,
//    DeleteuseraccountComponent,
    PopupSignupComponent,
//    PopupInterestComponent,
//    PopupIphoneComponent,
    PopupReportComponent,
//    PopupDetailComponent,
    DeleteConfirmComponent,
    ZizDeleteConfirmComponent,
    PopupLogoutComponent,
//    HomeSideMenuComponent,
//    UserHeaderBeforeLoginComponent,
//    UserHeaderBeforeSignupComponent,
//    AdvHeaderBeforeLoginComponent,
//    AdvHeaderBeforeSignupComponent,
//    ResetconfirmComponent,
//    FillComponent,
    PopupLogComponent,
//    CoupanCheckComponent,
    ImageCroperComponent,
    profileimageCroperComponent,
//    LocaldbComponent,
//    AddResetconfirmComponent,
//    FeedtrackingComponent,
   
//    // ImageCropperComponent,
//   //  NouisliderComponent,
//    TodoComponent,
//    AdlandingComponent,
//    AdaccountComponent,
//    SettingsComponent,
   
//   //  TranslateModule.forRoot({
//   //           loader: {
//   //               provide: TranslateLoader,
//   //               useFactory: HttpLoaderFactory,
//   //               deps: [Http]
//   //           }
//   //       }),
//    CampaignListComponent,
//    DraftCampaignComponent,
//    ViewCampaignComponent,
//   AdvHeaderComponent,
   PopupSegmentComponent,
  payreceiptComponent,
  AdminImageCroperComponent,
//   PopupContactComponent,
//   PrivacyComponent,

   AdminLoginComponent,
   AdminResetconfirmComponent,
   AdvertiserUploadComponent,
   ResetpasswordComponent,
   UpdatePasswordComponent,
   SettingsComponent,
   LayoutComponent,
   UsersComponent,
   SidebarComponent,
   HeaderComponent,
  ActiveAdvertisementsComponent,
  AdvertisersComponent,
  AdminWallComponent,
  CompanyDetailsComponent,
  KeywordsComponent,
  PhrasesComponent,
  TransactionsComponent,
  CouponCodeComponent,
  CreateCouponCodeComponent,
  TargetAudienceCouponCodeComponent ,
  BranchCompanyComponent ,
  CompanyInfoComponent ,
  BranchInfoComponent,
  BasePriceStatesComponent ,
  BasePriceUsersComponent ,
  PriceGroupComponent,
  ReportedContentComponent,
  UsersReportedListComponent ,
  SegmentsComponent,
  UpdateSegmentsComponent,
  CreateSegmentsComponent,
  PaymentComponent
  ],
  imports: [
    UsersModule,
    AdvertiserModule,
    BrowserModule,
   // FormsModule,
   HttpClientModule,
    HttpModule,
    Ng2PaginationModule,
    NguiAutoCompleteModule,
    LyResizingCroppingImageModule,
    LyResizingCroppingSmallImageModule,
   // ReactiveFormsModule,
    routing,
  //  GooglePlaceModule,
//Ng2SmartTableModule,
//PushNotificationsModule,
    CarouselModule,
    //Angular2Csv,
    //DragScrollModule,
    // NouisliderModule,
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    BootstrapModalModule,
    // MyDatePickerModule,
    InfiniteScrollModule,
    BsDropdownModule.forRoot(),
    ImageUploadModule.forRoot(),
    UiSwitchModule,
//      MetaModule.forRoot(
//        {
//  useTitleSuffix: true,
//     defaults: {
//         title: 'hi testing',
//         titleSuffix: 'testing suffix',
//        'og:image': 'http://example.com/default-image.png',
//     'any other': 'arbitrary tag can be used'
//     }
//        }
//      ),
    // AgmCoreModule.forRoot({
    // apiKey: 'AIzaSyCiDwGsfKYQXJmng1YkY6MygWZB6pzYUoA',
    // libraries: ['places'],
//
//old key:   AIzaSyBoPTIO2sXbA8Wm76docEURyTGHLzhkZAI
  // }),
   DatePickerModule,
SharedAppModule,
NgIdleKeepaliveModule.forRoot()
  //  onesignal
  ],
  entryComponents: [
         PopupSignupComponent, 
        // PopupInterestComponent, 
        // PopupIphoneComponent,
        PopupReportComponent,
         PopupLogoutComponent,
        PopupLogComponent,
         PopupSegmentComponent,
        // CoupanCheckComponent,
         ImageCroperComponent,
         DeleteConfirmComponent,
         ZizDeleteConfirmComponent, 
        // PopupDetailComponent,
         profileimageCroperComponent,
        AdminImageCroperComponent,
        // PopupContactComponent
    ],
  providers: [
    ValidationService, 
    LoaderService, 
    IndexedDBService,
    TodoComponent, 
    LocalStorage, 
    AuthGuard, 
    AuthGuardRoute, 
    Entity, 
    MessageService,
    Meta,
    Title,
    Data],
    exports: [],


  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts